import { InspectionComment } from 'classes';
import ODataUtil from 'utils/ODataUtil';

const apiEndpoint = "/InspectionComment";

const getInspectionComments = async function getInspectionComments(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const model = InspectionComment;
  const endpoint = apiEndpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, { model, endpoint });
  return data;
}

export { getInspectionComments };